import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createBasket, updateBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { guestSelectors } from '@store/guest/selectors';
import { signIn } from '@store/guest/actions';
import { Facility } from './Facility';
import { yourJourneySelectors } from '@store/yourJourney';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
  basketGuests: basketSelectors.getBasketGuests(state),
  entityType: 'spa-facilities',
  upSellName: 'spa-facility',
  defaultTitle: 'SPA_FACILITY',
  userHasAccessToFacilities: guestSelectors.userHasAccessToSpaEntity(state, 'facilities'),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createBasket,
      updateBasket,
      signIn,
    },
    dispatch
  );

export const Container: any = connect(mapStateToProps, mapDispatchToProps)(Facility);
